import templateUrl from "emun.on-demand/media/edit-media-prompt.htm";
import EditMediaPromptController from "emun.on-demand/media/edit-media-prompt.controller";
import open from "webmodals/open";

let editMediaPrompt = options => {
  let modalInstance = open({
    size: options.size || "lg",
    backdrop: "static",
    templateUrl: options.templateUrl || templateUrl,
    controller: EditMediaPromptController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default editMediaPrompt;
